import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MediaTypeProvider } from './contexts/MediaTypeContext';
import { FilmFinder } from './components/FilmFinder';
import { MovieDetail } from './components/MovieDetail';
import { TVDetail } from './components/TVDetail';
import { PersonDetail } from './components/PersonDetail';

function App() {
  return (
    <MediaTypeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<FilmFinder />} />
          <Route path="/movie/:id" element={<MovieDetail />} />
          <Route path="/tv/:id" element={<TVDetail />} />
          <Route path="/person/:id" element={<PersonDetail />} />
        </Routes>
      </BrowserRouter>
    </MediaTypeProvider>
  );
}

export default App;
